import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a821f58c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center fs-6 fw-bold mb-2"
}
const _hoisted_2 = {
  class: "chip",
  title: "Σύρε για αλλαγή σειράς"
}
const _hoisted_3 = ["onClick", "onKeydown"]
const _hoisted_4 = {
  key: 2,
  class: "selected-chips"
}
const _hoisted_5 = { class: "chip-single" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (Array.isArray(_ctx.modelArray))
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, "Διαλέξτε τη σειρά που θέλετε να εμφανίζονται"))
      : _createCommentVNode("", true),
    (Array.isArray(_ctx.modelArray))
      ? (_openBlock(), _createBlock(_component_draggable, {
          key: 1,
          modelValue: _ctx.internalList,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalList) = $event)),
          "item-key": _ctx.keyName,
          animation: 150,
          "force-fallback": true,
          class: "selected-chips",
          tag: "ul"
        }, {
          item: _withCtx(({ element }) => [
            _createElementVNode("li", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.byId[element[_ctx.keyName]]?.[_ctx.labelKey] ?? element[_ctx.keyName]) + " ", 1),
              _createElementVNode("span", {
                class: "chip-remove",
                role: "button",
                "aria-label": "remove",
                tabindex: "0",
                onClick: _withModifiers(($event: any) => (_ctx.removeId(element[_ctx.keyName])), ["stop","prevent"]),
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                onKeydown: [
                  _withKeys(_withModifiers(($event: any) => (_ctx.removeId(element[_ctx.keyName])), ["stop","prevent"]), ["enter"]),
                  _withKeys(_withModifiers(($event: any) => (_ctx.removeId(element[_ctx.keyName])), ["stop","prevent"]), ["space"])
                ]
              }, "×", 40, _hoisted_3)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "item-key"]))
      : (_ctx.hasSingle)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            _createElementVNode("li", null, [
              _createElementVNode("span", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.singleLabel) + " ", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "chip-remove",
                  "aria-label": "remove",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeSingle && _ctx.removeSingle(...args)), ["stop","prevent"])),
                  onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"]))
                }, "×", 32)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
  ], 64))
}